import instanceAxios from '../config/api'
import { OnboardingStatus, Specification } from '../types/specification'

const API_URL = '/settings'

export const createSpecification = async (
  specification: Specification
): Promise<Specification> => {
  try {
    const response = await instanceAxios.post<Specification>(
      `${API_URL}`,
      specification
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to create specification.')
  }
}
export const getAllSpecifications = async () => {
  try {
    const response = await instanceAxios.get<Specification[]>(`${API_URL}`)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch specifications.')
  }
}
export const updateSpecification = async (
  id: string,
  settings: Specification
): Promise<Specification> => {
  try {
    const response = await instanceAxios.put<Specification>(
      `${API_URL}/${id}`,
      settings
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to update specification.')
  }
}

export const updateOnboarding = async (
  id: string,
  payload: {
    status: OnboardingStatus
    stepIndex?: number
    version?: string
  }
): Promise<Specification> => {
  try {
    const response = await instanceAxios.patch<Specification>(
      `${API_URL}/${id}/onboarding`,
      payload
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to update onboarding.')
  }
}
